import { format } from 'date-fns';

const PaymentType = {
  Gotovina: 1,
  Kartica: 2,
  Virman: 3,
};

const { Gotovina, Kartica, Virman } = PaymentType;

const PaymentTypeTranslations = {
  [Gotovina]: 'Gotovina',
  [Kartica]: 'Kartica',
  [Virman]: 'Virman',
};

const paymentTypesArray = [{
  id: Gotovina,
  label: 'Gotovina',
}, {
  id: Kartica,
  label: 'Kartica',
}, {
  id: Virman,
  label: 'Virman',
}];

const RMAProblemStatusCodes = {
  RECEIVED: 1,
  IN_PROCESSING: 2,
  REJECTED: 3,
  RESOLVED: 4,
};

const RMAProblemStatusCodesArray = [
  {
    id: 1,
    title: 'Zaprimljeno',
  },
  {
    id: 2,
    title: 'U obradi',
  },
  {
    id: 3,
    title: 'Odbijeno',
  },
  {
    id: 4,
    title: 'Riješeno',
  },
];

const OrderStatuses = [
  {
    id: -1,
    title: 'Prednarudžba',
  },
  {
    id: 1,
    title: 'Kreirano',
  },
  {
    id: 2,
    title: 'Odobreno',
  },
  {
    id: 3,
    title: 'Otkazano',
  },
  {
    id: 4,
    title: 'Završeno',
  },
  {
    id: 5,
    title: 'Završeno (isporučeno)',
  },
  {
    id: 6,
    title: 'Otkazano - spojeno',
  },
  {
    id: 7,
    title: 'Otkazano - razdvojeno',
  },
  {
    id: 8,
    title: 'Neisporučeno',
  },
  {
    id: 9,
    title: 'Kreirano - neplaćeno',
  },
  {
    id: 10,
    title: 'Plaćeno',
  },
];

const orderStatusesObject = {
  '-1': 'Prednarudžba',
  1: 'Kreirano',
  2: 'Odobreno',
  3: 'Otkazano',
  4: 'Završeno',
  5: 'Završeno (isporučeno)',
  6: 'Otkazano - spojeno',
  7: 'Otkazano - razdvojeno',
  8: 'Neisporučeno',
};

export default {
  addRecentlyViewedArticle(id) {
    const items = localStorage.getItem('articles');
    if (!items) {
      localStorage.setItem('articles', JSON.stringify([id]));
    } else {
      const parsedData = JSON.parse(items);
      const foundItem = parsedData.find((i) => i === id);
      if (!foundItem) {
        parsedData.push(id);
        localStorage.setItem('articles', JSON.stringify(parsedData));

        if (parsedData.length > 10) {
          parsedData.shift();
          localStorage.setItem('articles', JSON.stringify(parsedData));
        }
      }
    }
  },
  getRecentArticles() {
    const items = localStorage.getItem('articles');
    if (items) {
      return JSON.parse(items);
    }
    return [];
  },
  generateRange(start, end) {
    return Array(end - start + 1).fill().map((_, idx) => start + idx);
  },
  formatDate(date, dateFormat) {
    return format(new Date(date), dateFormat);
  },
  paymentTypesArray,
  PaymentTypeTranslations,
  RMAProblemStatusCodesArray,
  RMAProblemStatusCodes,
  OrderStatuses,
  orderStatusesObject,
};
